import {entity} from "../rpc/api";
import MessageList = entity.MessageList;
import moment from "moment";
import {Message} from "../../../domain/model/message";

class MessageConvertResponse {

    public static from(from: entity.Message): MessageConvertResponse {
        // Backend => FrontEnd における型変換
        const createdAtDate: Date = MessageConvertResponse.convertToDate(from.createdAt);

        return new MessageConvertResponse(
            from.id,
            from.roomID,
            from.fromID,
            from.toID,
            from.fromCompany,
            from.text,
            from.gsImageURL,
            from.signedImageURL,
            from.gsFileURL,
            from.signedFileURL,
            createdAtDate,
        )
    }

    // from型が、RTDB内のMessageになるので
    // fromId,toId,fromCompany,text,imageUrl,fileUrl,createdAt, しか存在しない
    // signedImageURL, signedFileURLは無いはずだが、揃えるため書いている
    // ここでgsからhttpへurl変換するのもいいかもしれないが、クリック時に行うこととしている。
    public static fromRTDB(key: string, roomID: string, from: any): Message {

        const createdAtDate: Date = MessageConvertResponse.convertToDateFromRTDB(from.createdAt);

        return new Message(
            key,
            roomID,
            from.fromId,
            from.toId,
            from.fromCompany,
            from.text,
            from.imageUrl,
            from.signedImageURL,
            from.fileUrl,
            from.signedFileURL,
            createdAtDate,
        );
    }

    // Backend => FrontEnd における型変換　日付があればDate変換　なければ今日のDateを入れる
    private static convertToDate = (dateString: string): Date => {
        return (dateString) ? moment(dateString, "YYYY-MM-DD HH:II:SS").toDate() : moment().toDate()
    };
    // RTDB => FrontEnd における型変換　日付があればDate変換　なければ今日のDateを入れる
    private static convertToDateFromRTDB = (dateString: string): Date => {
        return (dateString) ? moment(dateString).toDate() : moment().toDate()
    };

    constructor(public readonly id: string,
                public readonly roomID: string,
                public readonly fromID: string,
                public readonly toID: string,
                public readonly fromCompany: boolean,
                public readonly text: string,
                public readonly gsImageURL: string,
                public readonly signedImageURL: string,
                public readonly gsFileURL: string,
                public readonly signedFileURL: string,
                public readonly createdAt: Date
    ) {
    }

}

class MessageConvertResponseList {

    public static from(from: MessageList): MessageConvertResponseList {
        const items: MessageConvertResponse[] = [];

        from.items.map((item, index) => {
            return items.push(MessageConvertResponse.from(item as entity.Message))
        });

        return new MessageConvertResponseList(
            items,
        )
    };

    constructor(
        public readonly items: MessageConvertResponse[],
    ) {
    };

}

export {
    MessageConvertResponse,
    MessageConvertResponseList,
}


// WEBPACK FOOTER //
// ./src/infra/api/service/message_api_convert.ts